import React from 'react'

const SummaryPromoteLeadToSw = ({ comment, formik,projectRecordNumber }: any) => {
    return (
        <div>
            <h4 className='mb-4'>Summary Information</h4>
            <div className='br-gray p-2'>
                <h5 className='mt-2 color-red mb-2'>Project Information</h5>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Project Number :
                            </p>
                            <p>
                                {projectRecordNumber}
                            </p>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Superintendent :
                            </p>
                            <p>
                                {formik?.values?.promoteDetails?.superintendent?.value}
                            </p>
                        </div>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Sale Date :
                            </p>
                            <p>
                                {formik?.values?.promoteDetails?.leadSaleDate}

                            </p>
                        </div>
                    </div>
                    {/* <div className='col-md-6 mt-2'>
            <div className='d-flex'>
              <p className='w-50 mb-0'>
                Status :
              </p>
              <p>
                9999
              </p>
            </div>
          </div> */}
                    <div className='col-md-6 mt-2'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Sale Accepted Date :
                            </p>
                            <p>
                                {formik?.values?.promoteDetails?.leadSaleAcceptedDate}
                            </p>
                        </div>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Job Complete Date:
                            </p>
                            <p>
                                {formik?.values?.promoteDetails?.jobCompleteDate}

                            </p>
                        </div>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Warrenty End Date :
                            </p>
                            <p>
                                {formik?.values?.promoteDetails?.warrantyEndDate}

                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='br-gray p-2 mt-3'>
                <h5 className='mb-1 color-red'>Property Address:</h5>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Address Line 1 :
                            </p>
                            <p>
                                {formik?.values?.propertyAddress?.addressLine1}
                            </p>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Address Line 2 :
                            </p>
                            <p>
                                {formik?.values?.propertyAddress?.addressLine1}
                            </p>
                        </div>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                City :
                            </p>
                            <p>
                                {formik?.values?.propertyAddress?.cityName}

                            </p>
                        </div>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                State :
                            </p>
                            <p>
                                {formik?.values?.propertyAddress?.stateName}
                            </p>
                        </div>
                    </div>
                    <div className='col-md-6 mt-2'>
                        <div className='d-flex'>
                            <p className='w-50 mb-0'>
                                Zip:
                            </p>
                            <p>
                                {formik?.values?.propertyAddress?.zipCode}

                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='br-gray p-2 mt-3'>
                <h5 className='mb-1 color-red'>Comments:</h5>
                <p>{comment}</p>
            </div>
        </div>
    )
}

export default SummaryPromoteLeadToSw